import { render, staticRenderFns } from "./System.vue?vue&type=template&id=c71af26e&scoped=true"
import script from "./System.vue?vue&type=script&lang=js"
export * from "./System.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71af26e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c71af26e')) {
      api.createRecord('c71af26e', component.options)
    } else {
      api.reload('c71af26e', component.options)
    }
    module.hot.accept("./System.vue?vue&type=template&id=c71af26e&scoped=true", function () {
      api.rerender('c71af26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/System.vue"
export default component.exports